<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Breadcrumb :style="{margin: '5px 0'}">
        <BreadcrumbItem>支付管理 > <b>代理商订单列表</b></BreadcrumbItem>
      </Breadcrumb>
      <Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
            <span class="search_span_width">
				<span class="search_span_width_part1">用户ID：</span>
		  		<Input v-model="search.user_id" clearable style="width: 80px" />
				<span class="search_span_width_part1">产品ID：</span>
		  		<Input v-model="search.product_id" clearable style="width: 80px" />
                <span class="search_span_width_part1">支付状态：</span>
				 <Select v-model="search.pay_status" style="width:260px">
					 <Option value="0" :key="0">待支付</Option>
				        <Option value="2" :key="2">支付成功</Option>
						<Option value="1" :key="1">支付中</Option>
						<Option value="3" :key="3">支付失败</Option>
				</Select>
            </span>
        <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getOrderList()">搜索</Button>
      </Card>
      <Card>
        <Card id="tableContent" >
          <Table :columns="tableColumns" :data="order_list"></Table>
		  <Page :total="recordTotal" :current="page" :page-size="10" :show-elevator="true" @on-change="getOrderList"/>
		  
        </Card>
      </Card>
    </Content>

  </Layout>
</template>
<script>
export default {
  data(){
    return {
		search : {
			user_id:"",
			user_type:1,
			product_id:"",
			pay_status:-1,
		},
		showmodal:false,
		recordTotal:0,
		page:1,
		order_list:[],
		tableColumns:[
		{ title: '订单号', key: 'order_no', align: 'center',width:"230px" },
		{ title: '用户ID', key: 'user_id', align: 'center' },
		{ title: '产品ID', key: 'product_id', align: 'center' },
		{ title: '产品名称', key: 'product_name', align: 'center' },
		{ title: '金币抵扣', key: 'coin_fee', align: 'center' },
		{ title: '创建时间', key: 'created_at', align: 'center',width:"200px" },
		{ title: '支付时间', key: 'time_end', align: 'center',width:"200px" },
		{ title: '支付状态', key: 'pay_status', align: 'center',
			render: (h, params) => {
				var txt = '';
				if (params.row.pay_status =='0') {
					txt = '待支付';
				} else if (params.row.pay_status =='1') {
					txt = '支付中';
				} else if (params.row.pay_status =='2') {
					txt = '支付成功';
				} else if (params.row.pay_status =='3') {
					txt = '支付失败';
				}
				
				return h("div",{},txt);
			}
		}
		],
	}
  },
  mounted:function(){
    this.getOrderList();
  },
  computed:{
  },
  methods:{
	getOrderList(page = this.page) {
		this.page = page;
		let p = {'page' : page}
		let params = Object.assign(this.search, p);
		this.http.get('/admin/pay/orderList',{params:params}).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.order_list = data.data.list;
			this.recordTotal = data.data.total;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
  }
}
</script>
